import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { RmpvOficinaMensalModule } from '../rmpv-oficina-mensal/rmpv-oficina-mensal.module';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { RmpvOficinaFiltroComponent } from './rmpv-oficina-filtro/rmpv-oficina-filtro.component';
import { RmpvOficinaListaComponent } from './rmpv-oficina-lista/rmpv-oficina-lista.component';
import { RmpvOficinaService } from './rmpv-oficina-service/rmpv-oficina.service';
import { RmpvOficinaComponent } from './rmpv-oficina.component';


@NgModule({
  imports: [
      HttpClientModule,
      FormsModule,
      CommonModule,
      BrowserModule,
      ReactiveFormsModule,
      ComumModule,
      ChartsModule,
      RmpvOficinaMensalModule,
      NgbModule,
      TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    RmpvOficinaComponent
  ],
  declarations: [
    RmpvOficinaComponent,
    RmpvOficinaListaComponent,
    RmpvOficinaFiltroComponent,
  ],
  providers: [
    RmpvOficinaService,
  ]
})
export class RmpvOficinaModule { }
